import { SignInForm } from "@/components/auth/auth-forms";

export function SignInPage({
  onAuth,
}: {
  onAuth: () => void | Promise<void>;
}) {
  return <SignInForm onAuth={onAuth} />;
}
